import { c as _c } from "react/compiler-runtime";
import DOMPurify from 'dompurify';
import { HTMLAttributes, useMemo } from 'react';
export type HtmlBlockProps = {
  htmlString: string;
  tag?: 'div' | 'p' | 'script';
  type?: string;
} & HTMLAttributes<HTMLElement>;
export const HtmlBlock = t0 => {
  const $ = _c(15);
  let htmlString;
  let props;
  let t1;
  let type;
  if ($[0] !== t0) {
    ({
      htmlString,
      tag: t1,
      type,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = htmlString;
    $[2] = props;
    $[3] = t1;
    $[4] = type;
  } else {
    htmlString = $[1];
    props = $[2];
    t1 = $[3];
    type = $[4];
  }
  const Tag = t1 === undefined ? "div" : t1;
  const isScript = Tag === "script";
  let t2;
  bb0: {
    if (typeof window === "undefined") {
      t2 = htmlString;
      break bb0;
    }
    let t3;
    if ($[5] !== htmlString || $[6] !== isScript) {
      t3 = isScript ? htmlString : DOMPurify.sanitize(htmlString);
      $[5] = htmlString;
      $[6] = isScript;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = t3;
  }
  const htmlContent = t2;
  const t3 = isScript ? type || "text/javascript" : undefined;
  let t4;
  if ($[8] !== htmlContent) {
    t4 = {
      __html: htmlContent
    };
    $[8] = htmlContent;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== Tag || $[11] !== props || $[12] !== t3 || $[13] !== t4) {
    t5 = <Tag type={t3} dangerouslySetInnerHTML={t4} {...props} />;
    $[10] = Tag;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};